<template>
  <div class="unstyled-city-list container">
    <ul class="unstyled-city-list__cities">
      <li v-for="city in categories" :key="city" class="unstyled-city-list__city-item">
        <SButton
          @click="toggleCity(city)"
          class="unstyled-city-list__city-button"
          :colors="{ textColor: 'var(--color-night-blue-900)' }"
          :class="{ selected: selectedCities.includes(city) }"
        >
          <span class="unstyled-city-list__check-indicator"></span>
          <span class="unstyled-city-list__city-name">{{ city.name }}</span>
        </SButton>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';

const SButton = defineAsyncComponent(() => import('@/components/molecules/buttons/SButton.vue'));

const emit = defineEmits(['cities-selected']);

interface City {
  __typename: string;
  id: number;
  name: string;
  slug: string;
  tree_root: number;
  is_city: boolean;
  description: string;
  productCount: number;
  enambled: boolean;
}

interface Props {
  categories: City[];
}

withDefaults(defineProps<Props>(), {
  categories: []
});

const selectedCities = ref<City[]>([]);

const toggleCity = (city: City) => {
  if (selectedCities.value.includes(city)) {
    selectedCities.value = selectedCities.value.filter((c: City) => c !== city);
  } else {
    selectedCities.value.push(city);
  }
  emit('cities-selected', selectedCities.value);
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.unstyled-city-list {
  ul {
    list-style-type: none;
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  &__city-button {
    font-family: 'Labil Grotesk Thin';
    font-weight: 300;
    background: none;
    border: none;
    padding: 0.5rem;
    @include font-size(18px);
    cursor: pointer;
    text-align: left;
    display: flex;
    align-items: center;
    min-width: max-content;
    position: relative;
    padding-left: 1.3rem;

    @include bp(sm-up) {
      @include font-size(30px);
      padding-left: 1.7rem;
    }
  }

  &__city-button.selected {
    color: var(--color-primary);
    font-family: 'Labil Grotesk Regular';
  }

  &__check-indicator {
    position: absolute;
    left: 0.3rem;
    top: 45%;
    transform: translateY(-50%);
    width: 1rem;
    height: 1rem;
    display: block;
    @include bp(sm-up) {
      left: 0.3rem;
    }
  }

  &__city-button.selected .unstyled-city-list__check-indicator::after {
    content: '';
    position: absolute;
    border-bottom: 2px solid var(--color-primary);
    border-left: 2px solid var(--color-primary);
    width: 0.6rem;
    height: 0.3rem;
    transform: rotate(-45deg);
    left: 0;
    top: 50%;
    margin-top: -0.2rem;

    @include bp(sm-up) {
      width: 1rem;
      height: 0.5rem;
    }
  }
  &__city-name {
    display: inline-block;
  }
}
</style>
